export const MIN_PLATE_NUMBER_LENGTH = 5;
export const MAX_PLATE_NUMBER_LENGTH = 10;
